// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2975r","title":"Header_title__3Q17W","left":"Header_left__1Gs0D","clinicName":"Header_clinicName__2NkUd"};